






























import { Component, Vue } from 'vue-property-decorator'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import VModal from '@/components/VModal.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/account/types'
import ValidatedForm from '@/utilities/validation/validatedform'
import FormField from '@/utilities/validation/formfield'
import emailValidator from '@/utilities/validators/email'
import nonEmptyValidator from '@/utilities/validators/nonempty'
import translator from '@/utilities/translator'

@Component({ components: { VButton, VInput, VModal } })
export default class Login extends Vue {
  @Action('login', { namespace: 'account' }) loginAction!: types.LoginAction
  @Action('resetPassword', { namespace: 'account' }) resetPasswordAction!: types.ResetPasswordAction

  private loggingIn = false
  private sendingReset = false
  private showForgotModal = false
  private modalStep = 1
  private ua = (this as any).$ua

  private loginForm = new ValidatedForm({
    email: new FormField(emailValidator, ''),
    password: new FormField(nonEmptyValidator, '')
  })

  private forgotForm = new ValidatedForm({
    email: new FormField(emailValidator, '')
  })

  private forgotPassword () {
    this.sendingReset = true
    if (this.forgotForm.validateForm()) {
      this.resetPasswordAction(this.forgotForm.fields.email.value).then(() => {
        this.modalStep = 2
        this.ua.trackEvent('account', 'password-forgot-success', true)
      }).catch(() => {
        this.ua.trackEvent('account', 'password-forgot-failed', true)
      }).finally(() => {
        this.sendingReset = false
      })
    }
  }

  private login () {
    if (this.loginForm.validateForm()) {
      (this as any).$ua.trackEvent('account', 'login-attempt', 'true')
      this.loggingIn = true
      this.loginAction({ username: this.loginForm.fields.email.value, password: this.loginForm.fields.password.value }).then(() => {
        (this as any).$ua.trackEvent('account', 'login-success', 'true')
        this.$router.push({ name: 'learnHome' })
      }).catch(() => {
        this.loginForm.fields.password.serverError = (translator as any).login.wrongLogin
      }).finally(() => {
        this.loggingIn = false
      })
    }
  }
}
